import React from "react";
import { IntlProvider } from "react-intl";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { flatten } from "flat";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";

import { UiFeedbackProvider } from "./context/ui-feedback/ui-feedback";
import { TemplatesProvider } from "./context/templates/templates";
import { ServiceWorksheetProvider } from "./context/service-worksheet/service-worksheet";
import { translation } from "./translation/translation";
import { App } from "./App";

import "./style/style.scss";

const msalInstance = new PublicClientApplication(msalConfig);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <IntlProvider
        messages={flatten({ ...translation })}
        locale="hu"
        defaultLocale="hu"
      >
        <UiFeedbackProvider>
          <ServiceWorksheetProvider>
            <TemplatesProvider>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </TemplatesProvider>
          </ServiceWorksheetProvider>
        </UiFeedbackProvider>
      </IntlProvider>
    </MsalProvider>
  </React.StrictMode>,
);
